export const data = [
  {
    name: "Drizzly",
    tech: "JavaScript | HTML | CSS | OpenWeatherMap API | Geocodio API",
    problem:
      "Getting a forecast from popular weather apps can be a painful experience due to sluggish performance, intrusive pop ups, and unnecessary page elements. This prevents users from easily finding the forecast data they are looking for.",
    solution:
      "Drizzly provides users with a clean interface and simple user experience to help them find the forecast they are looking for quickly.",
    imageURL: "../images/drizzly.png",
    linkURL: "http://www.drizzly.jesserobledo.xyz/",
    gitHubURL: "http://github.com/jjrobledo/Drizzly-Weather-Forecasts",
  },
  {
    name: "PodcastApp",
    tech: "JavaScript | Node.js | React | Express.js | MongoDB | HTML | CSS | JWT, Material UI",
    problem:
      "Most podcast apps are integrated into large music platforms. Since these platforms are music first, it can be difficult to browse and search podcast content.",
    solution:
      "Podcast App is a podcast exclusive web app that provides users with the ability to save their favorite podcasts to a feed and listen to podcast episodes without being distracted by content or features unrelated to podcasts.",
    imageURL: "../images/pod.png",
    linkURL: "http://www.podcast.jesserobledo.xyz/",
    gitHubURL: "http://github.com/jjrobledo/podcast-app",
  },
  {
    name: "Outdoor Voice",
    tech: "JavaScript | Node.js | React | Express.js | Mapbox | Cloudinary | MongoDB | HTML | CSS",
    problem:
      "Some social media users want to share and explore geolocated pictures on an interactive social map so that other users may explore places or things of interest. But, none of the major social media platforms place an emphasis on sharing content geographically.",
    solution:
      "Outdoor Voice lets users share and explore content on an interactive web map.",
    imageURL: "../images/outdoor.png",
    linkURL: "http://www.outdoorvoice.jesserobledo.xyz/",
    gitHubURL: "http://github.com/jjrobledo/Outdoor-Voice",
  },
];
